export default {
    pageName: 'อุณหภูมิสูง',
    search: {
        title: '',
        placeholder: 'ค้นหาชื่อ'
    },
    times: 'ครั้ง',
    header: {
        detail: 'รายละเอียด',
        temp: 'อุณหภูมิ'
    }
}
